/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState } from 'react';
import BucketIcon from '@svg/bucket_icon';
import Autocomplete from '@mui/material/Autocomplete';

import { Box, CircularProgress, InputAdornment } from '@mui/material';
import { useTheme } from '../../styles';
import { AutocompleteContainer, AutocompleteInput, AutocompletePopperPortal } from './Base';
import { BucketListItem } from './ListItem/BucketListItem';

interface Props {
  value: string;
  onChange: (event: React.SyntheticEvent<Element, Event>, newValue: any | null) => void;
  disabled?: boolean;
  loading?: boolean;
  labels: any[];
  placeholder?: string;
  indexes: any[];
}

export const Buckets: React.FC<Props> = (props) => {
  const autocompleteRef = useRef(null);
  const theme = useTheme();

  const { value, onChange, disabled, labels, placeholder, loading } = props;
  const [open, setOpen] = useState<boolean>(false);

  return (
    <AutocompleteContainer open={open}>
      <Autocomplete
        value={labels.find((item) => item.value === value) || null}
        ref={autocompleteRef}
        onChange={(event, newValue) => {
          onChange(event, newValue);
          setOpen(false);
          (document?.activeElement as HTMLElement)?.blur();
        }}
        disabled={disabled}
        PopperComponent={AutocompletePopperPortal}
        // groupBy={(option) => option?.metadata?.group}
        renderOption={(props, option) => <BucketListItem {...props} option={option} />}
        autoHighlight
        options={labels.filter((label) => !props.indexes.some((index) => index.index === label.label))}
        disablePortal
        getOptionLabel={(option) => option?.label || ''}
        renderInput={(params) => (
          <AutocompleteInput
            open={open}
            ref={params.InputProps.ref}
            inputProps={params.inputProps}
            placeholder={placeholder}
            disabled={disabled}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
            endAdornment={loading ? <CircularProgress sx={{ color: theme.primary }} size={14} /> : null}
            startAdornment={
              value && (
                <InputAdornment position='start'>
                  <Box
                    component='span'
                    sx={{
                      width: 16,
                      height: 16,
                      flexShrink: 0,
                      borderRadius: '3px',
                      mr: 0.35,
                      ml: 0.31,
                      mt: '0px',
                    }}
                  >
                    <BucketIcon height={16} color={theme.primary} />
                  </Box>
                </InputAdornment>
              )
            }
          />
        )}
      />
    </AutocompleteContainer>
  );
};
